import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import Router from './router/Router';

import 'primereact/resources/themes/omega/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import './index.styles';

let store = configureStore();
let rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.render(
    <Provider store={store}>
      <Router />
    </Provider>,
    rootElement
  );
}



// WEBPACK FOOTER //
// ./src/index.js